<template>
	<el-form ref="form" class="searchForm1" label-width="80px" style="text-align: left;" size="small">
		<el-row type="flex" :gutter="5">
			<el-col :span="6">
				<el-form-item label="任务编号">
					<el-input class="searchInput" placeholder="请输入任务编号" v-model="searchParams.TaskInstance">
					</el-input>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="任务名称">
					<el-input class="searchInput" placeholder="请输入任务名称" v-model="searchParams.TaskName">
					</el-input>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="执行状态">
					<el-tooltip class="item" effect="dark" :content="stateName" placement="top">
						<el-select class="searchInput" collapse-tags multiple v-model="searchParams.state" @change="stateChange"
						 placeholder="请选择">
							<el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-tooltip>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-tooltip class="item" effect="dark" :content="taskType" placement="top">
					<el-form-item label="任务类型">
						<el-select collapse-tags class="searchInput" @change="taskTypeChange" multiple v-model="searchParams.TaskType"
						 placeholder="请选择">
							<el-option v-for="item in taskTypeOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-tooltip>
			</el-col>
		</el-row>
		<el-row type="flex">
			<el-col :span="7">
				<el-form-item label="创建时间">
					<el-date-picker v-model="createtimeRange" type="daterange" align="right" unlink-panels range-separator="至" class="datePicker"
					 start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
					</el-date-picker>
				</el-form-item>
			</el-col>
			<el-col :span="7">
				<el-form-item label="创建人">
					<ayb-select-user :isRadio="true" @getValue="getCreateUser" ref="selectedCreateUser"></ayb-select-user>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="执行人">
					<ayb-select-user :isRadio="true" @getValue="getExcuteUser" ref="selectedExcuteUser"></ayb-select-user>
				</el-form-item>
			</el-col>
			<el-col :span="3">
				<el-form-item>
					<div class="btnPanel">
						<el-button class="btn" type="primary" @click="onSearch">搜索</el-button>
						<el-button class="btn" @click="onClear">清空</el-button>
					</div>
				</el-form-item>
			</el-col>
		</el-row>
	</el-form>
</template>

<script>
	import exportExcel from "@/components/common/exportExcelComponent.vue";
	import { GetTaskTypeList } from "@/api/modules/basicData/task";
	import { getToken } from "@/util/auth";
	const cookieUser = getToken();
	import {
		setConfig,
		getConfig,
		getAllSelectedParamsConfigs
	} from "@/api/modules/basicData/commonData.js";
	export default {
		name: "TaskSearch",
		data() {
			return {
				pickerOptions: {
					shortcuts: [{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							}
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							}
						}
					]
				},
				templateVisible: false,
				templateData: [],
				currentTemplateRow: null,
				selectedCreateUser: [],
				selectedExcuteUser: [],
				stateName: '', //执行状态
				taskType: '', //任务类型
				taskClass: '', //任务等级
				source: '', //保修来源
				searchParams: {
					TaskInstance: "",
					ExcuteState: "0,1,2,3,5,-1",
					TaskName: "",
					CreateTime2: "",
					CreateTime1: "",
					CreateUser: {},
					ExcuteUser: {},
					TaskType: [],
					state: ["0","1","2","3","5"],
					TypeIndex: "",
					TaskRightId: "",
					TaskDegree: []
				},
				createtimeRange: [],
				stateOptions: [
					{
						label: "待接收",
						value: "0"
					},
					{
						label: "执行中",
						value: "1"
					},
					{
						label: "已完成",
						value: "2"
					},
					{
						label: "已关闭",
						value: "3"
					},
					{
						label: "挂起中",
						value: "5"
					},
					{
						label: "已作废",
						value: "-1"
					}
				], //任务状态
				exportCols: [
					"任务编号",
					"执行状态",
					"任务名称",
					"创建人",
					"创建时间",
					"报修来源",
					"任务类型",
					"执行人员",
					"服务台",
					"接收时间",
					"完成时间",
					"任务等级",
					"关注度"
				],
				exportFields: [
					"INSTANCE",
					"TASKSTATENAME",
					"TASKNAME",
					"CREATEUSERNAME",
					"CREATETIME",
					"CREATESOURCE",
					"TASKTYPENAME",
					"EXCUTEUSERNAME",
					"SERVERCENTERNAME",
					"ACCEPTTIME",
					"COMPLETETIME",
					"TASKDEGREE",
					"FOCUSDEGREE"
				],
				exportData: [], //导出数据
				taskTypeOptions: JSON.parse(localStorage.getItem('TaskType')).map(function(val) {
					return {
						label: val.NAME,
						value: val.ID
					};
				}),
				createUser: null,
				excuteUser: null
			};
		},
		created() {
			// GetTaskTypeList().then(data => {
			// 	if (!data) return;
			// 	this.taskTypeOptions = data.map(function(val) {
			// 		return {
			// 			label: val.NAME,
			// 			value: val.ID
			// 		};
			// 	});
			// });

		},
		methods: {
			getCreateUser(val) {
				this.createUser = val[0];
			},
			stateChange(vId) { //这个vId也就是value值
				this.stateName = ''
				var arr = [];
				this.stateOptions.forEach((a) => {
					vId.forEach((c) => {
						if (a.value == c) {
							arr.push(a.label);
						}
					})
				})
				this.stateName = arr.join(",")
			},
			taskTypeChange(vId) { //任务类型
				var arr = [];
				this.taskTypeOptions.forEach((a) => {
					vId.forEach((c) => {
						if (a.value == c) {
							arr.push(a.label);
						}
					})
				})
				this.taskType = arr.join(",")
			},
			getExcuteUser(val) {
				this.excuteUser = val[0];
			},
			onSearch() {
				let para = Object.assign({}, this.searchParams);
				if (this.createtimeRange.length === 2) {
					para.CreateTime1 = this.createtimeRange[0];
					para.CreateTime2 = this.createtimeRange[1];
				}
				if (this.searchParams.state.length == 0) {
					para.ExcuteState = "";
				} else {
					para.ExcuteState = this.searchParams.state.join();
				}
				para.TaskType = this.searchParams.TaskType.join();
				if (!this.searchParams.TypeIndex) {
					para.TypeIndex = "-1";
				}
				if (this.createUser) {
					para.CreateUser = {
						ID: this.createUser.UserId,
						NAME: this.createUser.Name,
						DEPTID: this.createUser.DeptID,
						DEPTNAME: this.createUser.DeptName
					};
				}
				if (this.excuteUser) {
					para.ExcuteUser = {
						ID: this.excuteUser.UserId,
						NAME: this.excuteUser.Name,
						DEPTID: this.excuteUser.DeptID,
						DEPTNAME: this.excuteUser.DeptName
					};
				}
				this.$emit("onSearch", para)
				//this.$store.dispatch("changeTaskParas", para);
			},
			onClear(type) {
				this.searchParams = {
					TaskInstance: "",
					ExcuteState: "0,1,2,3,5",
					TaskName: "",
					CreateTime2: "",
					CreateTime1: "",
					CreateUser: {},
					ExcuteUser: {},
					state: ["0","1","2","3","5"],
					TaskType: [],
					ServerCenterIds: "",
					TypeIndex: "",
				};
				this.createtimeRange = [];
				this.$refs.selectedCreateUser.reset();
				this.$refs.selectedExcuteUser.reset();
				if(!type){
					this.onSearch();
				}
				// this.$store.dispatch("changeTaskParas", this.searchParams);
			},
		},
		mounted() {
			this.stateOptions.forEach((c) => {
				if (c.value == this.searchParams.state) {
					this.stateName = c.label
				}
			})
			let type = this.$route.query.type;
			if (!type) type = 2;
			switch (parseInt(type)) {
				case 1:
					this.searchParams.CurrentUserId = "";
					break;
				case 2:
					this.searchParams.CurrentUserId = cookieUser.userId; //个人任务
					break;
				case 3:
					this.taskTypeName = "任务组";
					break;
				default:
					this.searchParams.CurrentUserId = cookieUser.userId; //默认个人任务
					break;
			}
			this.onSearch();
			//this.$store.dispatch("changeTaskParas", this.searchParams);
		},
		components: {
			exportExcel
		}
	};
</script>

<style scoped>
	.el-autocomplete {
		width: 200px;
	}

	.searchInput {
		max-width: 200px;
		margin-right: 2px;
	}

	.datePicker {
		max-width: 240px;
		margin-right: 2px;
	}

	.btn {
		width: 100px;
		margin-left: 2px;
		margin-right: 2px;
	}

	.exportbtn {
		display: inline-block;
	}

	.searchForm1 {
		margin: 0 20px 0px;
	}

	.searchForm1 .el-form-item {
		margin-bottom: 5px;
	}

	.btnPanel {
		display: flex;
	}

	.el-col {
		margin-top: 8px;
	}
</style>
